import { useState, useEffect } from 'react';
import { axiosInstance } from 'utils/axios';

// material-ui
import { Box, Button, Grid, Typography, TextField, Select, MenuItem, Autocomplete, CircularProgress, Checkbox } from '@mui/material';

import { gridSpacing } from 'app/constant';
import { deepPurple } from '@mui/material/colors';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import StickyHeadTable from './components/StickyHeadTable';
import { warningAlert, successAlert, errorAlert } from 'ui-component/Toasts';
import useFetchData from 'hooks/useFetchData';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';

const AmbassadorLevel = () => {
    const token = useSelector(selectCurrentToken);

    const [ambassadorLevels, setAmbassadorLevels] = useState([]);
    const [ambassadorLevelsLoading, setAmbassadorLevelsLoading] = useState(false);

    const fetchAmbassadorLevel = async () => {
        let ambassadorClaimsUrl = `/AmbassadorLevels/All`;

        setAmbassadorLevelsLoading(true);
        try {
            const res = await axiosInstance.get(ambassadorClaimsUrl, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setAmbassadorLevels(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setAmbassadorLevelsLoading(false);
        }
    };

    useEffect(() => {
        fetchAmbassadorLevel();
    }, []);

    return (
        <Grid container item xs={12} padding="20px">
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {ambassadorLevelsLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable ambassadorLevels={ambassadorLevels} fetchAmbassadorLevel={fetchAmbassadorLevel} />
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default AmbassadorLevel;
